(function () {
  // ═══════════════════════════════════════════
  // WISHLIST — localStorage + UUID cookie
  // ═══════════════════════════════════════════

  var STORE_KEY  = 'kk_wishlist';
  var COOKIE_KEY = 'wl_uid';

  // ── UUID cookie ──────────────────────────────
  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : undefined;
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  if (!getCookie(COOKIE_KEY)) {
    setCookie(COOKIE_KEY, uuidv4(), 365);
  }

  // ── Storage helpers ──────────────────────────
  function wlGet() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || []; }
    catch (e) { return []; }
  }

  function wlSet(arr) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(arr)); }
    catch (e) {}
  }

  function wlHas(id) {
    id = String(id);
    return wlGet().some(function (p) { return String(p.id) === id; });
  }

  function wlAdd(product) {
    var arr = wlGet();
    var id  = String(product.id);
    if (!arr.some(function (p) { return String(p.id) === id; })) {
      arr.push(product);
      wlSet(arr);
    }
  }

  function wlRemove(id) {
    id = String(id);
    wlSet(wlGet().filter(function (p) { return String(p.id) !== id; }));
  }

  // ── UI sync ──────────────────────────────────
  function updateAllButtons() {
    var btns = document.querySelectorAll('[data-wl-toggle]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var id  = btn.getAttribute('data-wl-id');
      if (wlHas(id)) {
        btn.classList.add('wl-active');
        btn.setAttribute('aria-pressed', 'true');
      } else {
        btn.classList.remove('wl-active');
        btn.setAttribute('aria-pressed', 'false');
      }
    }
  }

  function updateCountBadges() {
    var count  = wlGet().length;
    var badges = document.querySelectorAll('[data-wl-count]');
    for (var i = 0; i < badges.length; i++) {
      var badge = badges[i];
      if (count > 0) {
        badge.textContent = count > 99 ? '99+' : String(count);
        badge.classList.remove('hidden');
      } else {
        badge.classList.add('hidden');
      }
    }
  }

  // ── Pop animation ────────────────────────────
  function popBtn(btn) {
    btn.classList.remove('wl-pop');
    void btn.offsetWidth;
    btn.classList.add('wl-pop');
    setTimeout(function () { btn.classList.remove('wl-pop'); }, 300);
  }

  // ── Floating heart burst (only on .wl-heart-btn card hearts, add only) ──
  function kkHeartBurst(btn) {
    if (!btn.classList.contains('wl-heart-btn') && !btn.classList.contains('wl-title-btn')) return;
    var offsets = [{ x: -5, delay: 0 }, { x: 4, delay: 100 }, { x: -1, delay: 180 }];
    offsets.forEach(function(o) {
      var p = document.createElement('span');
      p.className = 'kk-heart-particle';
      p.textContent = '♥';
      p.style.bottom = '50%';
      p.style.left = 'calc(50% + ' + o.x + 'px)';
      p.style.animationDelay = o.delay + 'ms';
      btn.appendChild(p);
      p.addEventListener('animationend', function() { if (p.parentNode) p.parentNode.removeChild(p); }, { once: true });
    });
  }

  // ── HTML escape ──────────────────────────────
  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ── Fade-in with IntersectionObserver ───────
  function initFadeIn(container) {
    var cards = container.querySelectorAll('.kk-hidden');
    if (!cards.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < cards.length; i++) {
        cards[i].classList.remove('kk-hidden');
        cards[i].classList.add('kk-reveal');
      }
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.remove('kk-hidden');
          entries[i].target.classList.add('kk-reveal');
          obs.unobserve(entries[i].target);
        }
      }
    }, { threshold: 0.05 });
    for (var i = 0; i < cards.length; i++) {
      obs.observe(cards[i]);
    }
  }

  // ── Wishlist page renderer ───────────────────
  // Renders cards using the same fcg2-card / product--card HTML structure as
  // the collection page, so all scoped CSS in wishlist-page.liquid applies.
  function renderWishlistPage() {
    var container = document.querySelector('[data-wl-page]');
    if (!container) return;

    var items   = wlGet();
    var emptyEl = document.getElementById('wl-empty-state');

    if (items.length === 0) {
      if (emptyEl) emptyEl.style.display = '';
      container.innerHTML = '';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';

    var html = '';
    for (var i = 0; i < items.length; i++) {
      var p   = items[i];
      var img = p.image
        ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" data-fcg2-main-img>'
        : '';

      var swatchHtml = '';
      if (p.colors && p.colors.length > 0) {
        swatchHtml = '<div class="fcg2-color-swatches" data-fcg2-swatches data-color-idx="0">';
        for (var j = 0; j < p.colors.length && j < 8; j++) {
          var c = p.colors[j];
          swatchHtml += '<button class="fcg2-swatch' + (j === 0 ? ' fcg2-swatch--active' : '') + '"' +
            ' title="' + esc(c.c) + '" aria-label="' + esc(c.c) + '"' +
            ' style="background-color:' + esc(c.b) + '"' +
            ' data-color="' + esc(c.c) + '"' +
            ' data-img-src="' + esc(c.img || p.image || '') + '"' +
            (j === 0 ? ' data-is-default="true"' : '') +
            '></button>';
        }
        swatchHtml += '</div>';
      }

      html += [
        '<div class="product--card fcg2-card kk-hidden">',
          '<div class="product--card-inner animate-hover image-hover" data-fcg2-card-inner>',
            '<div class="product--card-image width-100 pos-relative">',
              '<a href="' + esc(p.url) + '" class="product--image d-block width-100" data-fcg2-image-link>',
                '<div class="media">' + img + '</div>',
              '</a>',
              '<button type="button" class="wl-page--remove"',
                ' aria-label="Remove ' + esc(p.title) + ' from wishlist"',
                ' data-wl-remove-id="' + esc(String(p.id)) + '">',
                '<svg viewBox="0 0 24 24" fill="none">',
                  '<line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>',
                  '<line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>',
                '</svg>',
              '</button>',
            '</div>',
            '<div class="product--card-detail">',
              '<div class="product--card-detail-inner">',
                '<div class="product--card-detail-content">',
                  '<div class="fcg2-footer">',
                    '<a href="' + esc(p.url) + '" class="fcg2-title">' + esc(p.title) + '</a>',
                    '<div class="fcg2-row2">',
                      '<div class="fcg2-bottom-row">',
                        '<div class="fcg2-price-wrap">',
                          '<span class="fcg2-price">' + esc(p.price) + '</span>',
                        '</div>',
                      '</div>',
                      swatchHtml,
                    '</div>',
                  '</div>',
                '</div>',
              '</div>',
            '</div>',
          '</div>',
        '</div>'
      ].join('');
    }
    container.innerHTML = html;
    if (window.__kkWLInitSwatches) window.__kkWLInitSwatches();
    initFadeIn(container);
  }

  // ── Toggle click (cards + PDP) ───────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wl-toggle]');
    if (!btn) return;
    e.preventDefault();

    var id = btn.getAttribute('data-wl-id');
    if (!id) return;

    if (wlHas(id)) {
      wlRemove(id);
    } else {
      var colors = [];
      try { colors = JSON.parse(btn.getAttribute('data-wl-colors') || '[]'); } catch (e) {}
      wlAdd({
        id:     id,
        handle: btn.getAttribute('data-wl-handle') || '',
        title:  btn.getAttribute('data-wl-title')  || '',
        url:    btn.getAttribute('data-wl-url')     || '/products/' + (btn.getAttribute('data-wl-handle') || ''),
        image:  btn.getAttribute('data-wl-image')   || '',
        price:  btn.getAttribute('data-wl-price')   || '',
        colors: colors
      });
      kkHeartBurst(btn);
    }

    popBtn(btn);
    updateAllButtons();
    updateCountBadges();
    renderWishlistPage();
  });

  // ── Remove from wishlist page ────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wl-remove-id]');
    if (!btn) return;
    wlRemove(btn.getAttribute('data-wl-remove-id'));
    updateAllButtons();
    updateCountBadges();
    renderWishlistPage();
  });

  // ── Re-sync on section load (theme editor) ───
  document.addEventListener('shopify:section:load', function () {
    updateAllButtons();
    updateCountBadges();
  });

  // ── Init ─────────────────────────────────────
  function init() {
    updateAllButtons();
    updateCountBadges();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
